import type { QueryClient } from "@tanstack/react-query";

/** Receipt writes change both the batch price and the detail page's evidence. */
export function invalidateItemPurchasingCosts(queryClient: QueryClient, workspaceId: string) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: ["/api/items/purchasing-costs", workspaceId] }),
    queryClient.invalidateQueries({
      predicate: ({ queryKey }) =>
        queryKey[0] === "/api/items"
        && queryKey[2] === "receipts"
        && queryKey[3] === workspaceId,
    }),
  ]);
}